import CRUDService from "./base/CRUDService";

export default class BizStepService extends CRUDService {

  static ALL_URL = 'ton/v1/biz-steps';

  getBaseURL() {
    return "ton/v1/biz-steps/";
  }

}



// WEBPACK FOOTER //
// ./src/services/BizStepService.js